const Form046TC = {
    stepName: {
        statement: "重要事項",
        information: "基本資料",
        confirmation: "確認",
    },
    title: {
        title1: "續訂租約",
        title2: "證明文件",
        title3: "a) 租約",
        title4: "b) 其他（例如: 物業可作分租用途及收取租金的證明文件）",
        title5: "個人資料收集聲明",
        information: "資料",
        informationText1: `本人現通知教育局，本幼稚園暨幼兒中心已續訂租約，租期由`,
        informationText2: `至`,
        informationText3: `，為期`,
        informationText4: `，期間租金為每月`,
        informationText5: `元，並請教育局在新租約生效後繼續發放租金津貼。`,
    },
    content: {
        content1a: `本人現通知教育局，本幼稚園暨幼兒中心已續訂租約，租期`,
        content1b: `為期`,
        content2: `期間租金為每月 `,
        content3: `並請教育局在新租約生效後繼續發放租金津貼。`,
    },
    note: {
        note1: {
            title: `1.	你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：`,
            subtitle: "收集個人資料的目的",
            content1:
                "(a)	就非牟利幼稚園暨幼兒中心租約更新，辦理有關處理、核實及查證的事務；",
            content2:
                "(b)	就上文(a)項所述的處理、核實及查證，辦理有關把個人資料與政府相關政策局／部門資料庫進行核對程序的事務；",
            content3:
                "(c)	為核實／更新教育局的記錄，辦理有關把個人資料與教育局資料庫進行核對程序的事務；",
            content4:
                "(d)	辦理有關培訓及發展的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
            content5:
                "(e)	辦理有關處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計的事務；",
            content6: "(f)	辦理有關編製統計資料、研究材料及政府刊物的事務；以及",
            content7:
                "(g)	辦理有關施行及強制執行規則及規例 [包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]的事務；及《幼兒服務條例》(香港法例第243章)及其附屬法例 [即《幼兒服務規例》(香港法例第243A章)]的事務",
        },
        note2: {
            title: `2.	你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。`,
        },
        note3: {
            title: `3.	你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：`,
            subtitle: "可獲轉移資料者",
            content1: "(a)	政府其他政策局及部門，以用於上文第1段所述的用途；",
            content2: "(b)	與本表格相關的學校，以用於上文第1段所述的用途；",
            content3: "(c)	你曾就披露個人資料給予訂明同意；以及",
            content4:
                "(d)	根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        },
        note4: {
            title: `4.	你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 <a href='mailto: jokc@edb.gov.hk'>jokc@edb.gov.hk</a>。`,
            subtitle: "查閱個人資料",
        },
    },
    label: {
        termsConditions: "本人答應將任何多付與本幼稚園之款項交還政府。",
        reimbursementCheck:
            "如發還校舍租金申請獲得批准，本人將確保所有循使用校舍而得的收入，包括於課餘時間由學校或校外人士舉辦的收費活動，均納入學校的賬目內，經會計師核實後呈交教育局。",
        termFrom: "租期由",
        termTo: "租期至",
        years: "為期",
        year: "年",
        month: "個月",
        day: "天",
        payableMonth: "租金為每月$",
        documentaryEvidence: "現附上下列證明文件，以支持本人之申請：",
        attachment: "租約",
        otherAttachment: "其他（例如: 物業可作分租用途及收取租金的證明文件）",
        statement: "本人已閱讀、明白及同意上述條款及細則。",
        iAmSmartText:
            "本人理解申請人和學校審批人需要擁有「智方便+」帳戶才能處理申請。",
        supervisorName: "校監姓名",
        kindergartenName: "幼稚園名稱",
        kindergartenAddress: "幼稚園地址",
        specify: "請列明",
        autoGenerate: "自動填寫",
        naOption: "不適用",
    },
    errorMsg: {
        least30Days: "請輸入完整月份",
    },
    importantNote:
        "沒有「智方便+」戶口的申請人須把已填妥的申請表交回幼稚園及幼兒中心聯合辦事處處理（地址：香港太古城太古灣道14號6樓602室）。請確保已為郵件支付足夠郵資，以免未能送達本局。郵資不足的郵件，一律會由香港郵政處理。",
};
export default Form046TC;
